import React, { useContext, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalStateDataContext } from '../../context-api/GlobalStateDataProvider';
import RunCircleIcon from '@mui/icons-material/RunCircle';
import { getUrlParams } from '../../global/getUrl';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { GenerateAllTimeSlotsForDelivery } from '../../global/generateDeliveryTimeSlots';
import { isMobile } from '../../global/ScreenSizeHelper';

function RadioIcon({ checked }) {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: '50%',
        border: checked ? '6px solid #f97316' : '2px solid #111827',
        background: '#fff',
        flexShrink: 0,
        transition: 'all 0.2s ease',
      }}
    />
  );
}

function GiftItem({ item, selected, onClick, disabled }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        padding: '12px 14px',
        borderRadius: 10,
        border: selected ? '2px solid #f97316' : '1px solid #d1d5db',
        background: selected ? '#fff7ed' : '#ffffff',
        cursor: 'pointer',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          style={{
            width: 26,
            height: 26,
            borderRadius: 8,
            border: selected ? '2px solid #f97316' : '1px solid #9ca3af',
            background: disabled ? '#e5e7eb' : selected ? '#fed7aa' : '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: disabled ? '#9ca3af' : '#c2410c',
            fontSize: 14,
            fontWeight: 700,
          }}
        >
          {selected && !disabled ? '✓' : ''}
        </div>
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: '#111827' }}>{item.name}</div>
          <div style={{ fontSize: 12, color: '#6b7280' }}>{item.size}</div>
        </div>
      </div>
      <div style={{ fontSize: 16, fontWeight: 700, color: '#16a34a' }}>
        {item.name === 'none' ? '' : 'Free'}
      </div>
    </button>
  );
}

export default function DeliveryOptionsNewSlots(props) {
  const navigate = useNavigate();
  const { OnLoadInformation, onLoadInfoResponse } = useContext(GlobalStateDataContext);
  const { customerInfoData } = useContext(LoginDataContext);
  const handleClickRedirect = async () => navigate(`/customeraccount/deliveryaddress`);

  const {
    productsData = {},
    sortedKitchenData,
    activeButton,
    selectedDeliveryOption,
    setSelectedDeliveryOption,
    selectedStandardItem,
    setSelectedStandardItem,
    selectedPickupItem,
    setSelectedPickupItem,
    setActiveButton,
    restaurantList,
    fullDeliverySlotObj,
    subtotalInCart,
  } = useContext(OnTheMenuDataContext);
  const {
    address,
    delivery_agreement_fees,
    delivered_by,
    delivery_kitchen_fee,
    pickup_order_promotion,
    package_plan,
  } = sortedKitchenData;
  const { storename: urlStoreName } = getUrlParams();

  const StandardDeliveryPromotion =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.standard_delivery_promotion;
  const deliveryAgreementFees = delivery_agreement_fees?.[0]?.percentageToPay_byKitchen;
  const minimumAmountSpend = delivery_agreement_fees?.[0]?.minimumAmountSpend;

  const baseFeeKey =
    package_plan === 'basic' ? 'delivery_fee' : 'delivery_fee_enterprise_merchant_cust';

  const StandardDelivery =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.standard_delivery?.[baseFeeKey] || 0;

  const PriorityDelivery =
    onLoadInfoResponse?.data?.data?.data?.operationFlags?.priority_delivery?.[baseFeeKey] || 0;

  const DisplayStandardDeliveryFee =
    delivered_by === 'kitchen' ? delivery_kitchen_fee : StandardDelivery;

  const UrlAndProductKitchenAreSame =
    productsData?.data?.data?.[urlStoreName]?.kitchenName === urlStoreName;

  const CustomerDeliveryAddresses = customerInfoData?.data?.data?.delivery_address || [];
  const KitchenPickUpAddress = address;

  const getAllDeliveryOptionSlots = useMemo(() => {
    if (!sortedKitchenData) return null;

    return GenerateAllTimeSlotsForDelivery({
      KitchenInfoData: sortedKitchenData,
      onLoadInfoResponse,
    });
  }, [sortedKitchenData, onLoadInfoResponse]);

  useEffect(() => {
    OnLoadInformation();
  }, []);

  let DistanceInMiles = 0.0;
  if (UrlAndProductKitchenAreSame) {
    const result = restaurantList.find((item) => item.kitchenName === urlStoreName);
    DistanceInMiles = result?.distanceAndETA?.roadMiles;
  }

  const DisplayAddress = () => {
    if (activeButton === 'delivery') {
      return (
        <div style={{ flex: 1, minWidth: 200 }}>
          {CustomerDeliveryAddresses.length > 0 &&
            CustomerDeliveryAddresses.filter((n) => n.isDefault_address).map((n, i) => {
              return (
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                  key={`${n.Geolocation.formattedAddress}_${i}`}
                >
                  <svg
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#111827'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z' />
                    <circle cx='12' cy='10' r='3' />
                  </svg>
                  <div style={{ fontSize: 14, fontFamily: 'Inter Bold', color: '#111827' }}>
                    {n.address}
                  </div>
                </div>
              );
            })}

          <button
            style={{
              //   marginTop: 10,
              border: '1px solid #d1d5db',
              background: '#fff',
              borderRadius: 5,
              marginTop: '8px',
              marginLeft: '25px',
              padding: '5px',
              fontSize: 12,
              color: '#374151',
              cursor: 'pointer',
            }}
            onClick={handleClickRedirect}
          >
            Edit address
          </button>
        </div>
      );
    }
    if (activeButton === 'pickup') {
      return (
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <RunCircleIcon sx={{ color: '#181436', fontSize: '25px', marginRight: '5px' }} />

            <div style={{ fontSize: 14, fontFamily: 'Inter Bold', color: '#111827' }}>
              {KitchenPickUpAddress}
            </div>
          </div>
          <div style={{ marginLeft: '32px', fontSize: '12px' }}>
            Pickup &nbsp; - {DistanceInMiles || 0} mi{' '}
          </div>
        </div>
      );
    }
  };

  const getDiscount = (percentage) => {
    if (!percentage) {
      return { text: '', type: null };
    }

    if (percentage >= 100) {
      return {
        type: 'free',
        text: 'Free standard delivery',
      };
    }

    return {
      type: 'percentage',
      text: `${percentage}% off delivery fee`,
    };
  };
  const discount = getDiscount(deliveryAgreementFees);
  const getStartTime = (timeRange) => {
    return timeRange?.split(' - ')[0] || '';
  };

  const DisableBtnRegional = subtotalInCart >= StandardDeliveryPromotion?.minimumAmountSpend;
  const DisableBtnPickupMerchant = subtotalInCart >= pickup_order_promotion?.minimumAmountSpend;

  if (activeButton === 'pickup') {
    return (
      <div
        style={{
          background: '#f3f4f6',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 600,
            background: '#fff',
            overflow: 'hidden',
          }}
        >
          {getAllDeliveryOptionSlots?.standard?.store_status !== 'open' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                background: '#fff7ed',
                border: '1px solid #fed7aa',
                padding: 10,
                fontSize: '14px',
                color: '#f97316',
                textTransform: 'capitalize',
              }}
            >
              {' '}
              {getAllDeliveryOptionSlots?.standard?.store_status}
            </div>
          )}
          <div
            style={{ padding: 16, borderBottom: '1px solid #e5e7eb', textTransform: 'capitalize' }}
          >
            {DisplayAddress()}
          </div>

          <div style={{ padding: 16 }}>
            <div
              style={{
                textAlign: 'center',
                fontSize: 13,
                color: '#9a3412',
                marginBottom: 18,
                fontWeight: 500,
              }}
            >
              Exact delivery will be calculated at checkout
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <button
                onClick={() => {
                  setSelectedDeliveryOption('pickup');
                  setSelectedStandardItem({ name: 'none', size: '' });
                }}
                style={{
                  border:
                    selectedDeliveryOption === 'pickup' ? '2px solid #f97316' : '1px solid #e5e7eb',
                  background: '#fff',
                  borderRadius: 10,
                  padding: 14,
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <RadioIcon checked={selectedDeliveryOption === 'pickup'} />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 12,
                        flexWrap: 'wrap',
                      }}
                    >
                      <div style={{ fontSize: 16, fontWeight: 600, color: '#111827' }}>Pickup</div>
                      {delivered_by === 'kitchen' &&
                        pickup_order_promotion?.pickup_promo_available === true && (
                          <div style={{ fontSize: 14, fontWeight: 600, color: '#16a34a' }}>
                            Free item on orders over ${pickup_order_promotion?.minimumAmountSpend}
                          </div>
                        )}
                    </div>
                    {selectedDeliveryOption === 'pickup' &&
                      getAllDeliveryOptionSlots?.pickup?.delivery_time_slot && (
                        <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>
                          Ready by{' '}
                          {getStartTime(getAllDeliveryOptionSlots?.pickup?.delivery_time_slot)}
                        </div>
                      )}
                  </div>
                </div>
              </button>

              {selectedDeliveryOption === 'pickup' &&
                delivered_by === 'kitchen' &&
                pickup_order_promotion?.pickup_promo_available === true && (
                  <div
                    style={{
                      marginTop: -4,
                      //   marginLeft: 34,
                      background: '#f0fdf4',
                      border: '1px solid #bbf7d0',
                      borderRadius: 10,
                      padding: 14,
                    }}
                  >
                    <div style={{ fontSize: 14, color: '#166534', fontWeight: 700 }}>
                      {`Free item on order over $${pickup_order_promotion?.minimumAmountSpend}`}
                    </div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
                      {'Choose 1 free item'}
                    </div>
                    <div style={{ display: 'grid', gap: 10, marginTop: 14 }}>
                      {pickup_order_promotion?.pickup_free_items?.map((item) => (
                        <GiftItem
                          key={item._id}
                          item={item}
                          selected={selectedPickupItem.name === item.name}
                          onClick={() => setSelectedPickupItem(item)}
                          // disabled={!DisableBtnPickupMerchant}
                        />
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (activeButton === 'delivery') {
    if (CustomerDeliveryAddresses.length === 0) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', margin: '20px' }}>
          <div
            style={{
              fontSize: '16px',
              color: 'black',
              fontFamily: 'Inter Bold',
              marginTop: '10px',
            }}
          >
            {' '}
            Add Delivery address{' '}
          </div>
          <div style={{ fontSize: '12px', color: 'gray' }}>
            {' '}
            Delivery options and delivery speeds may vary for different location
          </div>
          <button
            style={{
              fontSize: '14px',
              fontFamily: 'Roboto Medium',
              padding: '5px',
              marginTop: '10px',
              width: '100px',
            }}
            onClick={handleClickRedirect}
          >
            {' '}
            Add
          </button>
        </div>
      );
    }
    return (
      <div
        style={{
          background: '#f3f4f6',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 600,
            background: '#fff',
            overflow: 'hidden',
          }}
        >
          {getAllDeliveryOptionSlots?.standard?.store_status !== 'open' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                background: '#fff7ed',
                border: '1px solid #fed7aa',
                padding: 10,
                fontSize: '14px',
                color: '#f97316',
                textTransform: 'capitalize',
              }}
            >
              {' '}
              {getAllDeliveryOptionSlots?.standard?.store_status}
            </div>
          )}
          <div
            style={{ padding: 16, borderBottom: '1px solid #e5e7eb', textTransform: 'capitalize' }}
          >
            {DisplayAddress()}
          </div>

          <div style={{ padding: 16 }}>
            <div
              style={{
                textAlign: 'center',
                fontSize: 13,
                color: '#9a3412',
                marginBottom: 18,
                fontWeight: 500,
              }}
            >
              Exact delivery time will be calculated at checkout
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
                maxWidth: isMobile ? '100%' : '330px',
              }}
            >
              <button
                onClick={() => {
                  setSelectedDeliveryOption('standard');
                  setSelectedPickupItem({ name: 'none', size: '' });
                }}
                style={{
                  border:
                    selectedDeliveryOption === 'standard'
                      ? '2px solid #f97316'
                      : '1px solid #e5e7eb',
                  background: '#fff',
                  borderRadius: 10,
                  padding: 14,
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <RadioIcon checked={selectedDeliveryOption === 'standard'} />
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#111827' }}>
                      Standard Delivery -{' '}
                      <span style={{ color: '#111827' }}>{`$${DisplayStandardDeliveryFee}`}</span>
                    </div>
                    {getAllDeliveryOptionSlots?.standard?.delivery_time_slot && (
                      <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>
                        Arrives between {getAllDeliveryOptionSlots?.standard?.delivery_time_slot}
                      </div>
                    )}
                  </div>
                </div>
              </button>

              {selectedDeliveryOption === 'standard' &&
                deliveryAgreementFees > 0 &&
                delivered_by === 'kitchen' && (
                  <div
                    style={{
                      marginTop: -4,
                      //   marginLeft: 34,
                      background: '#fff7ed',
                      border: '1px solid #fed7aa',
                      borderRadius: 10,
                      padding: 14,
                      // maxWidth: '280px',
                      textAlign: 'center',
                    }}
                  >
                    <div
                      style={{
                        fontFamily: 'Inter Regular',
                        fontSize: '14px',
                        color: 'rgba(144, 68, 13, 1)',
                      }}
                    >
                      {discount.text &&
                        `${discount.text} when you spend $${minimumAmountSpend} or more`}
                    </div>
                  </div>
                )}

              {selectedDeliveryOption === 'standard' &&
                delivered_by !== 'kitchen' &&
                StandardDeliveryPromotion?.standard_delivery_promo_available === true && (
                  <div
                    style={{
                      marginTop: -4,
                      //   marginLeft: 34,
                      background: '#fff7ed',
                      border: '1px solid #fed7aa',
                      borderRadius: 10,
                      padding: 14,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        color: '#9a3412',
                        fontWeight: 400,
                        textAlign: 'center',
                      }}
                    >
                      {`Due to a driver shortage, standard delivery times are longer. Enjoy a free item on orders over $${StandardDeliveryPromotion?.minimumAmountSpend} `}
                    </div>
                    {/* <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
                      {'Choose 1 free item'}
                    </div> */}
                    <div style={{ display: 'grid', gap: 10, marginTop: 14 }}>
                      {StandardDeliveryPromotion?.standard_free_items?.map((item) => (
                        <GiftItem
                          key={item._id}
                          item={item}
                          selected={selectedStandardItem.name === item.name}
                          onClick={() => setSelectedStandardItem(item)}
                          // disabled={!DisableBtnRegional}
                        />
                      ))}
                    </div>
                  </div>
                )}

              {delivered_by !== 'kitchen' && (
                <button
                  onClick={() => {
                    setSelectedDeliveryOption('priority');
                    setSelectedStandardItem({ name: 'none', size: '' });
                    setSelectedPickupItem({ name: 'none', size: '' });
                  }}
                  style={{
                    border:
                      selectedDeliveryOption === 'priority'
                        ? '2px solid #f97316'
                        : '1px solid #e5e7eb',
                    background: '#fff',
                    borderRadius: 10,
                    padding: 14,
                    cursor: 'pointer',
                    textAlign: 'left',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                    <RadioIcon checked={selectedDeliveryOption === 'priority'} />
                    <div>
                      <div style={{ fontSize: 16, fontWeight: 600, color: '#111827' }}>
                        Priority Delivery -{' '}
                        <span style={{ color: '#111827' }}>{`$${PriorityDelivery}`}</span>
                      </div>
                      {getAllDeliveryOptionSlots?.priority?.delivery_time_slot && (
                        <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>
                          Arrives between {getAllDeliveryOptionSlots?.priority?.delivery_time_slot}
                        </div>
                      )}
                    </div>
                  </div>
                </button>
              )}

              <button
                onClick={() => {
                  setSelectedDeliveryOption('pickup');
                  setSelectedStandardItem({ name: 'none', size: '' });
                  setActiveButton('pickup');
                }}
                style={{
                  border:
                    selectedDeliveryOption === 'pickup' ? '2px solid #f97316' : '1px solid #e5e7eb',
                  background: '#fff',
                  borderRadius: 10,
                  padding: 14,
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <RadioIcon checked={selectedDeliveryOption === 'pickup'} />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 12,
                        flexWrap: 'wrap',
                      }}
                    >
                      <div style={{ fontSize: 16, fontWeight: 600, color: '#111827' }}>Pickup</div>
                      {delivered_by === 'kitchen' &&
                        pickup_order_promotion?.pickup_promo_available === true && (
                          <div style={{ fontSize: 14, fontWeight: 600, color: '#16a34a' }}>
                            Free item on orders over ${pickup_order_promotion?.minimumAmountSpend}
                          </div>
                        )}
                    </div>
                    {getAllDeliveryOptionSlots?.pickup?.delivery_time_slot && (
                      <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>
                        Ready by{' '}
                        {getStartTime(getAllDeliveryOptionSlots?.pickup?.delivery_time_slot)}
                      </div>
                    )}
                  </div>
                </div>
              </button>

              {selectedDeliveryOption === 'pickup' &&
                delivered_by === 'kitchen' &&
                pickup_order_promotion?.pickup_promo_available === true && (
                  <div
                    style={{
                      marginTop: -4,
                      background: '#f0fdf4',
                      border: '1px solid #bbf7d0',
                      borderRadius: 10,
                      padding: 14,
                    }}
                  >
                    <div style={{ fontSize: 14, color: '#166534', fontWeight: 700 }}>
                      {`Free item on order over $${pickup_order_promotion?.minimumAmountSpend}`}
                    </div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
                      {'Choose 1 free item'}
                    </div>
                    <div style={{ display: 'grid', gap: 10, marginTop: 14 }}>
                      {pickup_order_promotion?.pickup_free_items?.map((item) => (
                        <GiftItem
                          key={item._id}
                          item={item}
                          selected={selectedPickupItem.name === item.name}
                          onClick={() => setSelectedPickupItem(item)}
                          // disabled={!DisableBtnPickupMerchant}
                        />
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
